import _ from 'lodash';
import React from 'react';
import { UiThemeSetting } from '../graphql/generated/graphql';
import airtable from '../icons/prefilled/brands/airtable.svg';
import asana from '../icons/prefilled/brands/asana.svg';
import atlassian from '../icons/prefilled/brands/atlassian.svg';
import bamboohr from '../icons/prefilled/brands/bamboohr.svg';
import box from '../icons/prefilled/brands/box.svg';
import canva from '../icons/prefilled/brands/canva.svg';
import clickup from '../icons/prefilled/brands/clickup.svg';
import coda from '../icons/prefilled/brands/coda.svg';
import codepen from '../icons/prefilled/brands/codepen.svg';
import confluence from '../icons/prefilled/brands/confluence.svg';
import drawio from '../icons/prefilled/brands/drawio.svg';
import drive from '../icons/prefilled/brands/drive.svg';
import dropbox from '../icons/prefilled/brands/dropbox.svg';
import figma from '../icons/prefilled/brands/figma.svg';
import freshdesk from '../icons/prefilled/brands/freshdesk.svg';
import github from '../icons/prefilled/brands/github.svg';
import githubDark from '../icons/prefilled/brands/githubDark.svg';
import gitlab from '../icons/prefilled/brands/gitlab.svg';
import gliffy from '../icons/prefilled/brands/gliffy.svg';
import gmail from '../icons/prefilled/brands/gmail.svg';
import google from '../icons/prefilled/brands/google.svg';
import calendar from '../icons/prefilled/brands/googleCalendar.svg';
import doc from '../icons/prefilled/brands/googleDocs.svg';
import drawing from '../icons/prefilled/brands/googleDrawings.svg';
import form from '../icons/prefilled/brands/googleForms.svg';
import map from '../icons/prefilled/brands/googleMaps.svg';
import sheet from '../icons/prefilled/brands/googleSheets.svg';
import slide from '../icons/prefilled/brands/googleSlides.svg';
import guru from '../icons/prefilled/brands/guru.svg';
import height from '../icons/prefilled/brands/height.svg';
import helpscout from '../icons/prefilled/brands/helpscout.svg';
import hubspot from '../icons/prefilled/brands/hubspot.svg';
import intercom from '../icons/prefilled/brands/intercom.svg';
import invision from '../icons/prefilled/brands/invision.svg';
import iorad from '../icons/prefilled/brands/iorad.svg';
import jira from '../icons/prefilled/brands/jira.svg';
import jotform from '../icons/prefilled/brands/jotform.svg';
import jsfiddle from '../icons/prefilled/brands/jsfiddle.svg';
import linear from '../icons/prefilled/brands/linear.svg';
import loom from '../icons/prefilled/brands/loom.svg';
import lucidchart from '../icons/prefilled/brands/lucidchart.svg';
import lucidchartDark from '../icons/prefilled/brands/lucidchartDark.svg';
import ludus from '../icons/prefilled/brands/ludus.svg';
import microsoft from '../icons/prefilled/brands/microsoft.svg';
import excel from '../icons/prefilled/brands/microsoftExcel.svg';
import microsoft365 from '../icons/prefilled/brands/microsoft365.svg';
import outlook from '../icons/prefilled/brands/microsoftOutlook.svg';
import powerpoint from '../icons/prefilled/brands/microsoftPowerpoint.svg';
import teams from '../icons/prefilled/brands/microsoftTeams.svg';
import word from '../icons/prefilled/brands/microsoftWord.svg';
import miro from '../icons/prefilled/brands/miro.svg';
import mode from '../icons/prefilled/brands/mode.svg';
import monday from '../icons/prefilled/brands/monday.svg';
import notion from '../icons/prefilled/brands/notion.svg';
import okta from '../icons/prefilled/brands/okta.svg';
import onelogin from '../icons/prefilled/brands/onelogin.svg';
import oneloginDark from '../icons/prefilled/brands/oneloginDark.svg';
import otter from '../icons/prefilled/brands/otter.svg';
import pingboard from '../icons/prefilled/brands/pingboard.svg';
import pitch from '../icons/prefilled/brands/pitch.svg';
import pitchDark from '../icons/prefilled/brands/pitchDark.svg';
import productboard from '../icons/prefilled/brands/productboard.svg';
import quip from '../icons/prefilled/brands/quip.svg';
import rows from '../icons/prefilled/brands/rows.svg';
import salesforce from '../icons/prefilled/brands/salesforce.svg';
import shortcut from '../icons/prefilled/brands/shortcut.svg';
import slabIcon from '../icons/prefilled/brands/slabIcon.svg';
import slack from '../icons/prefilled/brands/slack.svg';
import slackApp from '../icons/prefilled/brands/slackApp.svg';
import slideshare from '../icons/prefilled/brands/slideshare.svg';
import smartsheet from '../icons/prefilled/brands/smartsheet.svg';
import smartsheetDark from '../icons/prefilled/brands/smartsheetDark.svg';
import tableau from '../icons/prefilled/brands/tableau.svg';
import todoist from '../icons/prefilled/brands/todoist.svg';
import trello from '../icons/prefilled/brands/trello.svg';
import twitter from '../icons/prefilled/brands/twitter.svg';
import typeform from '../icons/prefilled/brands/typeform.svg';
import typeformDark from '../icons/prefilled/brands/typeformDark.svg';
import vimeo from '../icons/prefilled/brands/vimeo.svg';
import whimsical from '../icons/prefilled/brands/whimsical.svg';
import wistia from '../icons/prefilled/brands/wistia.svg';
import wrike from '../icons/prefilled/brands/wrike.svg';
import youtube from '../icons/prefilled/brands/youtube.svg';
import zendesk from '../icons/prefilled/brands/zendesk.svg';
import zendeskDark from '../icons/prefilled/brands/zendeskDark.svg';
import guide from '../icons/prefilled/brands/zendeskGuide.svg';
import support from '../icons/prefilled/brands/zendeskSupport.svg';
import useUiTheme from '../utils/useUiTheme';
import styles from './ExternalBrandLogo.module.scss';
import SVGIcon from './SVGIcon';

type ProductImageDefinition = string | { light: string; dark: string };

export const PRODUCT_IMAGES = {
  airtable: { airtable },
  asana: { asana },
  atlassian: { atlassian, confluence, jira },
  bamboohr: { bamboohr },
  box: { box },
  clickup: { clickup },
  shortcut: { shortcut },
  clubhouse: { clubhouse: shortcut },
  drawio: { drawio },
  dropbox: { dropbox },
  figma: { figma },
  freshdesk: { freshdesk },
  github: { github: { light: github, dark: githubDark } },
  gitlab: { gitlab },
  gliffy: { gliffy },
  gmail: { gmail },
  google: {
    google,
    calendar,
    doc,
    drawing,
    drive,
    form,
    map,
    sheet,
    slide,
    youtube,
  },
  guru: { guru },
  height: { height },
  invision: { invision, v7: invision },
  iorad: { iorad },
  jotform: { jotform },
  linear: { linear },
  loom: { loom },
  lucidchart: { lucidchart: { light: lucidchart, dark: lucidchartDark } },
  ludus: { ludus },
  microsoft: { microsoft, excel, 365: microsoft365, powerpoint, teams, word },
  miro: { miro },
  mode: { mode },
  monday: { monday },
  notion: { notion },
  okta: { okta },
  onelogin: { onelogin: { light: onelogin, dark: oneloginDark } },
  outlook: { outlook },
  pingboard: { pingboard },
  productboard: { productboard },
  quip: { quip },
  salesforce: { salesforce },
  slack: { slack, 'slack-app': slackApp },
  slab: { slab: slabIcon },
  slideshare: { slideshare },
  todoist: { todoist },
  trello: { trello },
  vimeo: { vimeo },
  wistia: { wistia },
  wrike: { wrike },
  zendesk: { zendesk: { light: zendesk, dark: zendeskDark }, guide, support },
  otter: { otter },
  typeform: { typeform: { light: typeform, dark: typeformDark } },
  canva: { canva },
  smartsheet: { smartsheet: { light: smartsheet, dark: smartsheetDark } },
  twitter: { twitter },
  codepen: { codepen },
  jsfiddle: { jsfiddle },
  hubspot: { hubspot },
  helpscout: { helpscout },
  intercom: { intercom },
  whimsical: { whimsical },
  pitch: { pitch: { light: pitch, dark: pitchDark } },
  tableau: { tableau },
  rows: { rows },
  coda: { coda },
} as const satisfies {
  [brand: string]: Record<string, ProductImageDefinition>;
};

type BrandName = keyof typeof PRODUCT_IMAGES;

type ProductImages = {
  [K in BrandName]: { [I in K]: ProductImageDefinition } & Record<
    string,
    ProductImageDefinition
  >;
};

function getBrandImages<B extends BrandName>(brand: B): ProductImages[B] {
  return PRODUCT_IMAGES[brand];
}

export type BrandAndProductProps<B extends BrandName = BrandName> = B extends B
  ? {
      brand: B;
      product?: keyof ProductImages[B];
    }
  : never;

type ExternalBrandLogoProps<B extends BrandName> = {
  height?: number;
  inline?: boolean;
} & BrandAndProductProps<B>;

const ExternalBrandLogo = <B extends BrandName>({
  inline,
  ...props
}: ExternalBrandLogoProps<B>) => {
  const uiTheme = useUiTheme();
  const isDark = uiTheme === UiThemeSetting.Dark;
  const productName = props.product ?? props.brand;

  const brandImages = getBrandImages(props.brand);
  const image = brandImages?.[productName] ?? brandImages?.[props.brand];

  let svgIcon: string | null = null;
  if (typeof image === 'string') {
    svgIcon = image;
  } else if (typeof image === 'object' && image) {
    svgIcon = isDark ? image.dark : image.light;
  }

  if (!svgIcon) {
    return null;
  }

  return (
    <div
      aria-label={_.startCase(`${props.brand} ${productName} Logo`)}
      role="img"
      className={inline ? styles.inline : undefined}
    >
      <SVGIcon inline={inline} size={props.height}>
        {svgIcon}
      </SVGIcon>
    </div>
  );
};

export default ExternalBrandLogo;
